import { HelperService } from 'app/shared/services/helpers.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-common-hint',
  templateUrl: './hint.component.html',
  styleUrls: ['./hint.component.scss']
})
export class HintComponent implements OnInit {

  @Input()
  supportedFiles: Array<string>;
  constructor(private helperService: HelperService) {
  }

  get theMessage() {
    let message: string = null;
    switch (this.supportedFiles) {
      case this.helperService.allacceptedExtention:
        message = `allowed files: word, jpeg, pdf, excel, zip, rar, msg`;
        break;
      case this.helperService.acceptedExtentionPicAndPdf:
        message = `allowed files: pdf, jpeg`;
        break;

    }
    return message;
  }

  ngOnInit() {
  }

}
